import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c64a39c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "description mt-4" }

import { useRouter } from 'vue-router'

import Modal from '@/popup/components/shared/Modal/Modal'
import Button from '@/popup/components/shared/Button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordSuccess',
  props: {
    onCancel: { type: Function, default: () => ({}) }
  },
  setup(__props: any) {



const router = useRouter()

const onCancelCallback = () => {
  router.push({
    path: '/settings',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, { "extra-class": "wider" }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, {
        "extra-class": "darker blurry",
        onClick: onCancelCallback
      }),
      _createVNode(_unref(Modal).Content, { "extra-class": "wider" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Modal).Heading, { "extra-class": "larger" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('modal.restore_wizard.complete_title')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('settings.password.complete_message')), 1 /* TEXT */),
          _createVNode(Button, {
            "is-full-width": true,
            class: "mt-6",
            onClick: onCancelCallback
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('modal.restore_wizard.complete_close')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})